import { standaloneSearchBoxSetReducer as standaloneSearchBoxSet } from '../../standalone-search-box-set/standalone-search-box-set-slice.js';
import { fetchRedirectUrl, registerStandaloneSearchBox, resetStandaloneSearchBox, updateStandaloneSearchBoxRedirectionUrl, } from './standalone-search-box-set-actions.js';
/**
 * Loads the standalone search box set reducer and returns the available commerce standalone search box set action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the commerce standalone search box set action creators.
 *
 * @group Actions
 * @category StandaloneSearchBoxSet
 */
export function loadStandaloneSearchBoxSetActions(engine) {
    engine.addReducers({ standaloneSearchBoxSet });
    return {
        fetchRedirectUrl,
        registerStandaloneSearchBox,
        updateStandaloneSearchBoxRedirectionUrl,
        resetStandaloneSearchBox,
    };
}
